import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';
import {
  InputField,
  SmartInput,
  Textarea,
} from '../../components/FormElements/FormElements';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { orderSlice, orderState, tGlassworksValue } from './OrderSlice';

import { ClientsMenu } from '../../components/PredefinedMenus/PredefinedMenus';
// API
import { client, order_details_extended, storeOrder } from '../../services/api/api';
import {
   checkIfClientExisted, checkIfTotallyFilled
  , checkRequestNotRepeated_v2
  , enterButton, fetchGlassWorkData
  , get_index, handleKeyDown, handlePrices, iRow, price_related_keys, setTouchedAll
} from './common'
// Stylesheet
import './Order.css';


import {
  EllipsisLoader,
  ErrorMark,
  MySuccessMark,
} from '../../components/Loader/Loader';

import { havePermission } from '../../services/hoc/permissions';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';

import {
  CircularProgress,
  TableCell,
  TableRow,
} from '@mui/material';
import EditbleTable from '../../components/editble-table/Editable_table_v1';
import { useFormik } from 'formik';
import GreenButton from '../../components/buttons/green-button';
import WhiteButton from '../../components/buttons/white-button';
import { Cancel, Save } from '@mui/icons-material';

import { useGetGlasses } from '../../services/query/useGetGlasses';
import { useGetGlassesWork } from '../../services/query/useGetGlassesWork';
import { useGetPrices } from '../../services/query/useGetPrices';

import { useNotification } from '../../services/usenotification';

import { convertDate } from '../../services/convertDate';
import Backbutton from '../../components/buttons/backbutton/backbutton';
import InputTable from '../../components/editble-table/input_table';
import Title from '../../components/Title/Title';
import SettingContext from '../../services/context/setting-contentxt/setting-context';
import { AddOrderValidation } from './validation';
import { useAPI } from '../../services/hoc/useAPI';
import { useDebounce } from '../../services/hoc/useDebounce';
// interface iService {
//   glass_work_id: string;
//   glasswork_code: string;
//   piece_code: string;
//   length: string;
//   width: string;
//   piece_count: string;
//   glass_id: string;
//   glass_code: string;
//   serial_number: string;
// }
interface initialFormik extends storeOrder {

  glass_ids: number[],
  glass_work_ids: number[],
  client_number?: string,
  client?: client
}
const AddOrder =  (props: any) => {
  // Translation
  const t = useTranslation();
  const { alert, alertError500 } = useNotification();
 const {debounce,handlDebounce} = useDebounce(500)
  const [openToolTip, setOpenToolTip] = useState({
    glasses: false,
    glassworks: false,
  });
  const [isFetchingGlassWork, setIsFetchingGlassWork] = useState(false);
  const [isSucceed, setIsSucceed] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const selection_depend_on = useRef<null | string>('glasses');



  const ref1 = useRef<any>(null);
  const ref2 = useRef<any>(null);
  const ref3 = useRef<any>(null);
  const ref4 = useRef<any>(null);
  const ref5 = useRef<any>(null);
  const ref6 = useRef<any>(null);
  const ref7 = useRef<any>(null);
  const ref8 = useRef<any>(null);

  const [row, setRow] = useState<iRow>({});

  const state = useSelector((state: { order: orderState }) => state.order);
  const formik = useFormik<initialFormik>({
    initialValues: {
      glass_summary: '',
      glass_work_summary: '',
      glass_ids: [],
      glass_work_ids: [],
      summary: '',
      order_no: '',
      date: new Date().toLocaleDateString('en-CA'),
      delivery_date: '',
      order_details: [],
      client_id: -1
    },
    onSubmit: () => { },
    validationSchema: AddOrderValidation(checkIfClientExisted, state.client_list),
  });

  // Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { getGlasses, glassesData, glassesDataLoading, glassesError } =
    useGetGlasses();
  const {
    getGlassesWorks,

  } = useGetGlassesWork();
  const {
    pricesData,
    pricesDataLoading,
    pricesError,
    getPricesByGlasse,
    pricesByGlassData,
    pricesByGlassError,

    pricesByGlassLoading,
  } = useGetPrices();
  // Hooks

  const { isPc } = useContext(SettingContext)

const ENDPOINTS = useAPI()




  // First fetch

  useEffect(()=>{
    dispatch(orderSlice.actions.resetOrder())
  },[])

  useEffect(() => {
    if (!state.isLoaded && !state.isFetching) {
      //fetchGlasses()
      //fetchPricing()
      getGlasses(1);
      getGlassesWorks(1);
      //getPrices(1);

      //dispatch(orderSlice.actions.initFetchedIds({}))
      //dispatch(orderSlice.actions.initIdsPendingFetch({}))
    }
  }, []);
  useEffect(() => {
    if (state.client_list.length === 0 && !state.loadingClients) {
      fetchClientList()
    }
  }, [])

  useEffect(() => {
    dispatch(orderSlice.actions.initGlassworks())

  }, []);

  const fetchClientList = () => {
    dispatch(orderSlice.actions.setIsLoadingClients(true))
    ENDPOINTS.clients().index({ page: 1, page_size: 5000 })
      .then((response: any) => {
        dispatch(orderSlice.actions.setIsLoadingClients(false))
        let list = response.data.data.clients.map((client: any) => (
          {
            value: client.id,
            label: client.name, phoneNumber:
              client.phone, address: client.address_1,
            client_name: client.name,
            client_id: client.id
            , ...client
          }))
        dispatch(orderSlice.actions.setClientList({ list }))

      })
      .catch((err: any) => {
        dispatch(orderSlice.actions.setIsLoadingClients(false))
        alertError500(err)
      })

  }


  useEffect(() => {
    if (!glassesError) {
      if (glassesData && glassesData.length > 0) {
        let data = glassesData.map((ele) => ({ ...ele, value: ele.id }));
        dispatch(orderSlice.actions.setGlasses({ data, index: 'general' }));
      }
    }
  }, [glassesDataLoading]);



  useEffect(() => {
    if (!pricesError) {
      if (pricesData && pricesData.length > 0) {
        dispatch(orderSlice.actions.setPricing(pricesData));
      }
    }
  }, [pricesDataLoading]);



  useEffect(() => {
    if (row?.glass_id) {
      if (!pricesByGlassLoading) getPricesByGlasse(row.glass_id);
    }
  }, [row?.glass_id]);

  useEffect(() => {
    if (!pricesByGlassError) {
      let selected_glassworks =
        pricesByGlassData.length > 0 ? pricesByGlassData : null;
      if (
        selected_glassworks &&
        selected_glassworks.length > 0 &&
        selection_depend_on.current === 'glasses'
      ) {
        let data = selected_glassworks
          .map((ele: any) => ({
            ...ele,
            value: ele.gwid,
            name: ele.gwname,
          }))
          .filter((ele) => ele.is_priced === 1);
        let selectedGlassWorks = data
          ? data.filter((ele) => ele.gwid === row?.glass_work_id)
          : null;

        if (selectedGlassWorks && selectedGlassWorks.length === 0 && row) {
          let new_row = { ...row };
          new_row['glasswork_code'] = '';
          new_row['glass_work_id'] = -1;
          setRow((pre) => new_row);

        }
        // dispatch(
        //   orderSlice.actions.setGlassWords({
        //     data,
        //     index: 0,
        //   }),
        // );
      } else {
        let data: any[] | null =
          Boolean(selection_depend_on.current) &&
            selection_depend_on.current === 'glasses'
            ? []
            : null;
        if (row) {   
        let new_row = { ...row };

        new_row['glasswork_code'] = '';
        new_row['glass_work_id'] = -1;

        setRow((pre) => new_row);
      }


        // dispatch(
        //   orderSlice.actions.setGlassWords({
        //     data,
        //     index: 0,
        //   }),
        // );
      }
    }
  }, [pricesByGlassData]);







  const enterClicked = () => {
    if (row){
    let totally_filled = checkIfTotallyFilled(row);

    if (totally_filled) {
      addValuesTable();

    } else {
      alert(
        {
          en: 'Please you have to fill all the fileds',
          ar: 'رجاءا أدخل كل القيم أولا',
        },
        'info',
      );
    }}
  };


  const generateTableBody = () => (
    <TableRow
      style={{
        width: '100%',
      }}
      sx={{
        '.MuiTableCell-root': {
          borderColor: 'lightgray',
          borderLeft: '1px solid lightgray',
          borderLeftStyle: 'groove',
          padding:'1px'
        },
      }}>
      {isPc &&
        <TableCell >

          {enterButton(enterClicked)}
        </TableCell>}
      <TableCell

        align="right"
        style={{
          borderColor: openToolTip.glassworks
            ? 'var(--primary-color)'
            : undefined,
        }}>
        <select
          style={{
            width: '190px'
          }}
          ref={ref1}
          className="select tab_element_inputTable"
          name="glass_work_id"
          onKeyDown={handleKeyDown}
          value={row?.glass_work_id??''}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            handleRow(e)
          }>
          <option value={''}></option>
          {state.glassWorks[-999]
            ? state.glassWorks[-999].map((ele, index) => (
              <option value={ele.value ?? ''} key={`${index}-${ele}`}>
                {ele.name ?? ''}
              </option>
            ))
            : null}
        </select>
      </TableCell>
      <TableCell align="right"
      >
        <SmartInput
          ref={ref2}
          className="input  table_input tab_element_inputTable"
          value={row?.glasswork_code??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="glasswork_code"
          onKeyDown={handleKeyDown}
        />
      </TableCell>
      <TableCell align="right" >
        <SmartInput
          ref={ref3}
          className="input  table_input tab_element_inputTable"
          value={row?.piece_code??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="piece_code"
          onKeyDown={handleKeyDown}
        />
      </TableCell>
      <TableCell align="right" >
        <SmartInput
          ref={ref4}
          className="input  table_input tab_element_inputTable"
          value={row?.length??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="length"
        
          onKeyDown={handleKeyDown}
        />
      </TableCell>
      <TableCell  >
        <SmartInput
          ref={ref5}
          className="input  table_input tab_element_inputTable"
          value={row?.width??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="width"
      
          onKeyDown={handleKeyDown}
        />
      </TableCell>
      <TableCell >
        <SmartInput
          ref={ref6}
          className="input  table_input tab_element_inputTable "
          value={row?.piece_count??''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="piece_count"
         
          onKeyDown={handleKeyDown}
        />
      </TableCell>

      <TableCell >
        <select

          ref={ref7}
          className="select tab_element_inputTable"
          name="glass_id"
          value={row?.glass_id??''}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            handleRow(e)
          }
          onKeyDown={handleKeyDown}
          style={{
            borderColor: openToolTip.glasses
              ? 'var(--primary-color)'
              : undefined,
            width: '190px'

          }}>
          <option value={''}></option>
          {state.glasses['general']
            ? state.glasses['general'].map((ele, index) => (
              <option value={ele.value ?? ''} key={`${index}-${ele}`}>
                {ele.name ?? ''}
              </option>
            ))
            : null}
        </select>
      </TableCell>
      <TableCell  >
        <SmartInput
          ref={ref8}
          className="input  table_input tab_element_inputTable "
          value={row?.glass_code}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleRow(e)
          }
          name="glass_code"
          onKeyDown={handleKeyDown}
        />
      </TableCell>

    </TableRow>
  );


  const handleRow = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {

    if (state.order.orderstatus && state.order.orderstatus[0].code >= 3) return
    // define last index for summaries handler 

    if (e.target.name.includes("glass_id")) {

      let { glass_code } = handleCode({ index: -999, glass_id: parseInt(e.target.value) })

      handleFetchingGlasswork_v2(-999, parseInt(e.target.value))


      setRow((pre:iRow|undefined) => ({ ...pre, glass_code: glass_code
                                              , glass_id: parseInt(e.target.value) 
                                      
                                              }))
    }
    else if (e.target.name.includes("glass_work_id")) {
      let { glass_work_code } = handleCode({ index: -999, glass_work_id: parseInt(e.target.value) })
      setRow(pre => ({ ...pre
                      , glasswork_code: glass_work_code
                      , glass_work_id: parseInt(e.target.value) 
                      
                 
                    }))
    }
    else if (e.target.name.includes("glass_code")) {
      let { glass_id } = handleGlass_Glasswork({ index: -999, glass_code: e.target.value })
      if (glass_id) handleFetchingGlasswork_v2(-999, parseInt(glass_id?.toString()))
      setRow(pre => ({
        ...pre
        , glass_id: glass_id ?? -1
        , glass_code: e.target.value
        , glass_work_id: -1
        , glasswork_code: ''
      }))
    }
    else if (e.target.name.includes("glasswork_code")) {
      let { glass_work_id } = handleGlass_Glasswork({ index: -999, glass_work_code: e.target.value })
      setRow(pre => ({ ...pre
                       , glass_work_id: glass_work_id ?? -1
                       , glasswork_code: e.target.value 
                  
                      }))
    }
    else {

      setRow((pre) => ({ ...pre!, [e.target.name]: e.target.value }))
    }
  }


  const handleSummaries = (): {
    glass_summary: string,
    glass_work_summary: string,
    glass_ids: number[],
    glass_work_ids: number[],
  } | null => {

    if (formik.values.order_details && formik.values.order_details.length > 0) {

      let summary_glass: string[] = [];
      let summary_galss_work: string[] = [];
      let summary_glass_ids: number[] = [];
      let summary_glass_work_ids: number[] = [];
      formik.values.order_details.map((elem, index) => {
        if (elem.glass_id && state.glasses['general']) {

          let glass_name = '';
          let selectedGlass = state.glasses['general']
            ? state.glasses['general'].filter(
              (ele) => ele.id === Number(elem.glass_id),
            )
            : null;

          if (selectedGlass) glass_name = selectedGlass[0]?.name;
          if (
            glass_name &&
            !summary_glass_ids.includes(elem.glass_id)
          ) {

            summary_glass.push(glass_name);
            summary_glass_ids.push(elem.glass_id);
          }
        }

        if (elem.glass_work_id && state.glassWorks[index]) {
          let glasswork_name = '';
          let selectedGlasswork = state.glassWorks[index]
            ? state.glassWorks[index].filter(
              (ele) => ele.gwid === Number(elem.glass_work_id),
            )
            : null;

          if (selectedGlasswork) glasswork_name = selectedGlasswork[0]?.name;
          if (
            glasswork_name &&
            !summary_glass_work_ids.includes(elem.glass_work_id)
          ) {
            summary_galss_work.push(glasswork_name);
            summary_glass_work_ids.push(elem.glass_work_id);
          }
        }
      });

      if (summary_glass.length > 0 || summary_galss_work.length > 0) {
        // formik.setValues((pre) => ({
        //   ...pre,
        //   glass_summary: summary_glass.join(','),
        //   glass_ids: summary_glass_ids,
        //   glass_work_summary: summary_galss_work.join(','),
        //   glass_work_ids: summary_glass_work_ids,
        // }));
        return {
          glass_summary: summary_glass.join(','),
          glass_work_summary: summary_galss_work.join(','),
          glass_ids: summary_glass_ids,
          glass_work_ids: summary_glass_work_ids,

        }
      }

    }
    return null
  };



  const handleCode =
    ({ index, glass_id, glass_work_id }: { index: number, glass_id?: number, glass_work_id?: number })
      : { glass_code: string, glass_work_code: string, price?: number } => {

      let glass_code = ''
      let glass_work_code = ""
      if (glass_id) {
        let selectedGlass = state.glasses['general']
          ? state.glasses['general'].filter(
            (ele) =>
              ele.id === glass_id,
          )
          : null;
        if (selectedGlass && selectedGlass[0]) {
          glass_code = selectedGlass[0].code ?? ''
        }
      }
      if (glass_work_id) {
        let selectedGlassWorks = state.glassWorks[index]
          ? state.glassWorks[index].filter(
            (ele) =>
              ele.gwid === glass_work_id,
          )
          : null;

        if (selectedGlassWorks && selectedGlassWorks[0]) {
          glass_work_code = selectedGlassWorks[0].gwcode ?? ''
        }
      }
      return { glass_code, glass_work_code }
    }

  const handleGlass_Glasswork =
    ({ index, glass_code, glass_work_code }: { index: number, glass_code?: string, glass_work_code?: string })
      : { glass_id?: number, glass_work_id?: number, price?: number } => {

      let glass_id = undefined
      let glass_work_id = undefined
      let price = undefined
      if (glass_code) {
        let selectedGlass = state.glasses['general']
          ? state.glasses['general'].filter(
            (ele) =>
              ele.code === glass_code,
          )
          : null;
        if (selectedGlass && selectedGlass[0]) {
          glass_id = selectedGlass[0].id
        }
        //console.log('handleGlass',selectedGlass)
      }
      if (glass_work_code) {
        let selectedGlassWorks = state.glassWorks[index]
          ? state.glassWorks[index].filter(
            (ele) =>
              ele.gwcode === glass_work_code,
          )
          : null;
       //console.log('handle_Glasswork',selectedGlassWorks)
        if (selectedGlassWorks && selectedGlassWorks[0]) {
          glass_work_id = selectedGlassWorks[0].gwid
          price = selectedGlassWorks[0].price
        }
      }
      return { glass_id, glass_work_id, price }
    }

  const setGlassId = (index: number, glass_id: number) => {
    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let { glass_code } = handleCode({ index, glass_id })

      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_id = glass_id
      new_orderdetails[index].glass_work_id = -1
      new_orderdetails[index].glass_code = glass_code
      new_orderdetails[index].glasswork_code = ''
      new_orderdetails[index].price=0
      new_orderdetails[index].total_price=0
      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
  }

  const setGlassWorkId = (index: number, glass_work_id: number) => {
    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let { glass_work_code } = handleCode({ index, glass_work_id })

      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_work_id = glass_work_id
      new_orderdetails[index].glasswork_code = glass_work_code
      new_orderdetails[index]['total_price']=0
      new_orderdetails[index]['price']=0
      let [single_price,total_price,price,raw_price,min_area] = handlePrices(new_orderdetails[index],state)
      new_orderdetails[index]['total_price']=total_price
      new_orderdetails[index]['price']=price
      new_orderdetails[index]['single_price']=single_price
      new_orderdetails[index]['raw_price']=raw_price
      new_orderdetails[index]['area']=min_area
        
      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
  }

  const setGlassWorkCode = (index: number, glasswork_code: string) => {
    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let { glass_work_id, price } = handleGlass_Glasswork({ index, glass_work_code: glasswork_code })

      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_work_id = glass_work_id
      new_orderdetails[index].glasswork_code = glasswork_code
      new_orderdetails[index].price = 0

      //new_orderdetails[index].price = (price ?? 0) * (Number(new_orderdetails[index].piece_count ?? 0))

      handlDebounce({key_trigger:'glasswork_code'
                    ,values:new_orderdetails
                    ,helper:{index}})


      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
  }

  const setGlassCode = (index: number, glass_code: string): number | undefined => {
    let glass_id = undefined
    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let resu = handleGlass_Glasswork({ index, glass_code })
      
      glass_id = resu.glass_id

      let new_orderdetails = [...formik.values.order_details]
      new_orderdetails[index].glass_id = glass_id
      new_orderdetails[index].glass_code = glass_code
      new_orderdetails[index].glass_work_id = -1
      new_orderdetails[index].glasswork_code = ''
      new_orderdetails[index]['total_price']=0
      new_orderdetails[index]['price']=0
      new_orderdetails[index]['single_price']=0
      new_orderdetails[index]['raw_price']=0
            

      // handlDebounce({key_trigger:'glass_code'
      //               ,values:new_orderdetails
      //               ,helper:{index}
      // })


      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
    return glass_id
  }

  const setPrices = (index: number, input_name: price_related_keys, input_value: string) => {

    if (formik.values.order_details && formik.values.order_details.length > 0) {
      let new_orderdetails = [...formik.values.order_details]
      let target_line = new_orderdetails[index]
      target_line[input_name] = parseFloat(input_value)
      let [single_price, total_price, price,raw_price,area] = handlePrices(target_line,state)
      target_line.single_price = single_price
      target_line.total_price = total_price
      target_line.price = price
      target_line.raw_price=raw_price
      target_line.area=area

      formik.setValues(pre => ({ ...pre, order_details: new_orderdetails }))
    }
  }
   
     
 
  const customHandleChange = (e: React.ChangeEvent, index: number) => {
    // update index for summaries handler 

    if (havePermission('Add Order')) {
      let prices_keys = ['price']
      let target = e.target as HTMLInputElement
      let relate_prices_keys = ['width', 'length', 'piece_count']
      let match = target.name.match(/\[(\w+)\]$/)
      let _input_name = match ? match[1] : ''
      if (target.name.includes("glass_id")) {
        handleFetchingGlasswork_v2(index, parseInt(target.value))

        setGlassId(index, parseInt(target.value))
      }
      else if (target.name.includes("glass_work_id")) {
        setGlassWorkId(index, parseInt(target.value))
      }
      else if (target.name.includes("glasswork_code")) {
        setGlassWorkCode(index, target.value)
      }
      else if (target.name.includes("glass_code")) {
        let glass_id = setGlassCode(index, target.value)
        if (glass_id) handleFetchingGlasswork_v2(index, glass_id)
      }
      else if (relate_prices_keys.includes(_input_name)) {
        setPrices(index, _input_name as price_related_keys, target.value)

      }
       else if (prices_keys.includes(_input_name)) {
          if (state.order&& state.order.orderstatus && state.order.orderstatus[0].code > 1)return 
          let values = formik.values.order_details?[...formik.values.order_details]:[]
          values[index]['price']=parseInt(target.value)
          let [single_price ,total_price,price,raw_price] =handlePrices( values[index],state)
          values[index]['total_price']=total_price
          values[index]['raw_price']=raw_price
         
          //formik.setFieldValue(`order_details[${index}][price]`,target.value,false)
          formik.setValues(pre=>({...pre ,order_details:values}))
         }

      else {

        formik.handleChange(e);
      }
    } else {
      let message = t('no_add_permission');
      alert({ en: message, ar: message }, 'info');
    }
  };






  const dispatch_glasswork = (index: number, data: tGlassworksValue[]) => {


    dispatch(
      orderSlice.actions.setGlassWords({
        data,
        index: index,
      }))


  }


  const setRowFields = (empty_row: iRow, index: number) => {
    if (index === 0) {
      if (row){
      let [single_price, total_price,price, raw_price,min_area] = handlePrices(row,state)
      formik.setFieldValue('order_details', [{ ...row, total_price: total_price, single_price,price, raw_price, serial_number: 1,area:min_area }]);
      setRow((pre) => empty_row);}
    } else {
      if (row){
      let [single_price, total_price,price, raw_price,min_area] = handlePrices(row,state)
      let new_array = formik.values.order_details ? [...formik.values.order_details] : [];
      let new_row = {
        ...row,
        piece_count: row.piece_count,
        price,
        raw_price: raw_price,
        total_price: total_price,
        single_price: single_price,
        glass_id: row.glass_id
        , glass_work_id: row.glass_work_id
        , serial_number: index
        ,area:min_area
      };
      new_array.push(new_row);
      formik.setFieldValue('order_details', new_array);
      setRow((pre) => empty_row);
    }
    }
  }







  const handleFetchingGlasswork_v2 = async (index: number, glass_id: number) => {

    let request_is_made = checkRequestNotRepeated_v2(state.fetched_ids, glass_id)
    let is_existed: tGlassworksValue[] | null = null
    //is_existed = checke_GlassWork_existing(glass_id, state.glassWorks)

    if (request_is_made) {
      let found_index = get_index(state.fetched_ids, glass_id)

      if (found_index > -1) is_existed = state.fetched_glassworks[found_index]

      if (is_existed) {
        dispatch_glasswork(index, is_existed)
      }
      else {

        dispatch(orderSlice.actions.setIdsPendingFetch({ index, glass_id }))

      }
    }
    else {
      if (!isFetchingGlassWork) {


        let new_index = null


        let keys_fetched_ids = Object.keys(state.fetched_ids)
        new_index = keys_fetched_ids.length > 0 ? Math.max(...keys_fetched_ids.map(ele => parseInt(ele))) + 1 : 0


        dispatch(orderSlice.actions.setFetchedIds({ index: new_index, glass_id }))
      }
      let response = await fetchGlassWorkData(glass_id
        , index
        , ENDPOINTS
        , setIsFetchingGlassWork
   
      )

      if (response.data) {

        dispatch_glasswork(response.index, response.data)

      }
    }
  }



  const addValuesTable = () => {
     let empty_row:iRow = {
         glass_id:undefined,
         glass_code:'',
       
         glass_work_id:undefined,
         glasswork_code:'',
         length:undefined,
         width:undefined,
         piece_code:'',
         piece_count:undefined,
   
   
       };
    let index = formik.values.order_details?.length;
    if (index !== undefined) {

      handleFetchingGlasswork_v2(index, row?.glass_id??-1)
      dispatch(orderSlice.actions.deleteGlassWorks({ arr_index: ['-999'] }))
      setRowFields(empty_row, index)
    }
  }



  const submit = () => {
    if (!formik.isValid) {
      setTouchedAll(formik.setTouched, formik.errors)
      return;

    }
    let glass_summary = ''
    let glass_work_summary = ''
    let summary_results = handleSummaries()
    if (summary_results) {
      glass_summary = summary_results.glass_summary
      glass_work_summary = summary_results.glass_work_summary
    }
    setIsLoading(true);
    ENDPOINTS.orders()
      .store({
        client_id: formik.values.client?.id ? formik.values.client?.id : -1,
        date: convertDate(formik.values.date),
        delivery_date: formik.values.delivery_date ? convertDate(formik.values.delivery_date) : null,
        summary: Boolean(formik.values.summary) ? formik.values.summary : "No Note",
        glass_summary: glass_summary,
        glass_work_summary: glass_work_summary,
        order_no: formik.values.order_no,
        order_details: formik.values.order_details?.filter((ele) => ele.glass_id)
          .map((ele) => {
          
            return({
            glass_id: ele.glass_id,
            glass_work_id: ele.glass_work_id,
            piece_code: ele.piece_code,
            piece_count: ele.piece_count,
            width: ele.width,
            length: ele.length,
            area:  ele.area,
            total:ele.total_price,
            price: ele.price
          })}),
      })
      .then((res) => {
        setIsLoading(false);
        setIsSucceed(true);

        if (res.data.data && res.data.data.id) {
          navigate(`/orders/${res.data.data.id}`);
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        setIsFailed(true);
        alertError500(err);
      });
  };

  const handleRemoveLine = (arr_index: string[]) => {
    if (havePermission('Add Order')) {
      // let new_formoption = { ...formOptions };
      // new_formoption.current_index =
      //   new_formoption.current_index > 0
      //     ? new_formoption.current_index - 1
      //     : formik.values.order_details && formik.values.order_details?.length - 2 >= 0
      //       ? formik.values.order_details?.length - 2
      //       : 0;
      // new_formoption.dirty = true;
      let new_fields = formik.values.order_details?.filter(
        (ele, i) => !arr_index.includes(i.toString()),
      );
      dispatch(orderSlice.actions.deleteGlassWorks({ arr_index: arr_index }))


      // remove_id_glass_id_fetched(arr_index.map(ele=>parseInt(ele)))

      //setFormOptions((pre) => ({ ...pre, ...new_formoption }));
      formik.setValues((pre: any) => ({ ...pre, order_details: new_fields }));

    } else {
      let message = t('no_add_permission');
      alert({ en: message, ar: message }, 'info');
    }

  };


  const handleCopyLine = (arr_index: string[]) => {

    if (formik.values.order_details && formik.values.order_details?.length >= arr_index.length) {
      let new_rows = arr_index.map(ele =>
        ({...formik.values.order_details?.[parseInt(ele)]})
      )
      let new_details = [
        ...formik.values.order_details,
        ...new_rows
      ];
      dispatch(orderSlice.actions.copyGlassWorks({ arr_index }))
      formik.setFieldValue('order_details', new_details);

    }
  };

  const handleClientNumber = async (value: string) => {

    if (value) {
      let client = checkIfClientExisted(value, state.client_list)
      if (client) {
        formik.setFieldValue('client', client)
      }

    }
  }

  const formikChange = (e: React.ChangeEvent) => {
    if (havePermission('Add Order')) {
      formik.handleChange(e);
    } else {
      let message = t('no_add_permission');
      alert({ en: message, ar: message }, 'info');
    }
  };

  const formikBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.name === "client_number") {
      handleClientNumber(e.target.value)
    }

    formik.handleBlur(e)
  }



    //////////////// Debouncing //////////////////
  
    useEffect(()=>{
      if (debounce && Boolean(debounce?.key_trigger)){

        let {values,helper}=debounce

        if (helper && typeof(helper.index) !== undefined){
            if (debounce?.key_trigger === 'glasswork_code') {
          
                  let [single_price,total_price,price,raw_price,min_area] = handlePrices(values[helper.index],state)
                  values[helper.index]['total_price']=total_price
                  values[helper.index]['price']=price
                  values[helper.index]['single_price']=single_price
                  values[helper.index]['raw_price']=raw_price
                  values[helper.index]['area']=min_area
                  
              
  
            }
          //   else if (debounce?.key_trigger === 'glass_code') {
          //       let [single_price,total_price,price,raw_price,min_area] = handlePrices( values[helper.index])
          //       values[helper.index]['total_price']=0
          //       values[helper.index]['price']=0
          //       values[helper.index]['single_price']=0
          //       values[helper.index]['raw_price']=raw_price
            
            
          // }
  
        formik.setValues(pre => ({ ...pre, order_details: values }))
       
  
  }
  
    }
  },[debounce])
  

  let key1 = t('glass_work')
  let key2 = t("glass_code")
  let key3 = t("service")
  let key4 = t("category")
  let key5 = t("length")
  let key6 = t("width")

  let spans: { [key: string]: number } = {}
  let spans_1: { [key: string]: number } = {}
  let units: { [key: string]: string } = {}
  spans[key1] = 2
  spans[key2] = 2
  spans_1[key3] = 1
  spans_1[key4] = 1

  units[key5] = `(${t("cm")})`
  units[key6] = `(${t("cm")})`


  //console.log(formik.values)
  //console.log("state", state)
  //console.log('errors', formik.errors)
  //console.log("touched", formik.touched)
  //console.log('row',row)

  if (state.isFetching) {
    return (
      <Grid container>
        <Grid  size={12} display="flex" justifyContent={'center'}>
          <EllipsisLoader />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container paddingBottom={4}>
      <MySuccessMark succeed={isSucceed} setSucceed={setIsSucceed} />
      <ErrorMark failed={isFailed} setFailed={setIsFailed} />
      <Grid
        
        container
        size={12}
        rowGap={2}
        columnGap={1}
        justifyContent={'center'}>
        {/* <Grid  container size={12} justifyContent={'flex-end'}>
          <Backbutton previousPageRoute="/orders" />
        </Grid> */}
        <Title title={t("add_to_orders")} backbutton_path='/orders'/>
        <Grid  container size ={{sm:5,xs:12}}  sx={{
          padding: '0px'
        }}>
          <Grid  size={12}>
            <ClientsMenu
              client_list={state.client_list}
              name="client"
              placeholder={t('select_client') + ' *'}
              onBlur={formikBlur}
              onChange={
                havePermission('Add Order')
                  ? (selected: {
                    value: number;
                    label: string;
                    phoneNumber: string;
                    address: string;
                    client: { serial_no: string }
                  }) => {

                    // formik.setFieldValue('client', {
                    //   client_id: selected.value,
                    //   client_name: selected.label,
                    // });
                    formik.setValues((pre: any) => ({
                      ...pre,
                      client: {
                        id: selected.value,
                        name: selected.label,
                      },
                      client_number: selected.client.serial_no
                    }))
                  }
                  : () => {
                    let message = t('no_add_permission');
                    alert({ en: message, ar: message }, 'info');
                  }
              }
              value={
                formik.values.client && formik.values.client.id
                  ? {
                    value: formik.values.client?.id,
                    label: formik.values.client?.name,
                  }
                  : null
              }
              error={
                formik.errors.client
                  ? t('required_error')
                  : ''
              }
            />
          </Grid>

          <Grid  size={12}>
            <InputField
              name="date"
              type="date"
              label={t('order_date') + ' *'}
              onChange={formikChange}
              onBlur={formik.handleBlur}
              value={formik.values.date}
              error={
                formik.errors.date && formik.touched.date
                  ? t('required_error')
                  : ''
              }
            />
          </Grid>
          <Grid size={12}>
            <InputField
              name="delivery_date"
              onChange={formikChange}
              onBlur={formik.handleBlur}
              type="date"
              label={t('delivery_date') }
              value={formik.values.delivery_date}
              error={
                formik.errors.delivery_date && formik.touched.delivery_date
                  ? t('required_error')
                  : ''
              }
            />
          </Grid>
        </Grid>
        <Grid  container size={{sm:5,xs:12}} padding={0}>
          <Grid  size={12}>
            <InputField
              name="client_number"
              type="string"
              label={t('client_number') + ' *'}
              onChange={formikChange}
              onBlur={formikBlur}
              value={formik.values.client_number}
              error={
                formik.errors.client_number && formik.touched.client_number
                  ? formik.errors.client_number
                  : ''
              }
            />
          </Grid>
          <Grid size={12}>
            <Textarea
              name="summary"
              label={t('note')}
              onChange={formikChange}
              onBlur={formik.handleBlur}
              value={formik.values.summary}
              rows={4}
              error={
                formik.errors.summary && formik.touched.summary
                  ? t('required_error')
                  : ''
              }
            />
          </Grid>
        </Grid>


        <Grid  container size={12}>
          <InputTable
            headers={[
              t('glass_work'),
              t('glasswork_code'),
              t('piece_code'),
              t('length'),
              t('width'),
              t('piece_count'),
              t('glass'),
              t('glass_code'),
            ]}
            body={() => generateTableBody()}
            spans={spans}
            units={units}
          />
        </Grid>
        {!isPc && <Grid  container size={12} justifyContent={'center'}>
          {enterButton(enterClicked)}
        </Grid>}
        <Grid  container size={12}>
          <EditbleTable
            handleChange={customHandleChange}
            handleBlur={formik.handleBlur}
            error={formik.errors}
            has_general_options={true}
            array_name="order_details"
            lines_number={formik.values.order_details?.length ?? 0}

            values={(() => {
              let obj: { [key: number]: order_details_extended } = {};
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              formik.values.order_details
                ? formik.values.order_details.map(
                  (ele, index) =>
                  (obj[index] = {
                    glass_work_id: ele.glass_work_id,
                    glasswork_code: ele.glasswork_code,
                    piece_code: ele.piece_code,
                    length: ele.length,
                    width: ele.width,
                    piece_count: ele.piece_count,
                    price: ele.price,
                    total_price: ele.total_price,
                    glass_id: ele.glass_id,
                    glass_code: ele.glass_code,
                    serial_number: index + 1,
                  }),
                )
                : [
                  {
                    glass_work_id: '',
                    glasswork_code: '',
                    piece_code: '',
                    length: '',
                    width: '',
                    piece_count: '',
                    price: 0,
                    total_price: 0,
                    glass_id: '',
                    glass_code: '',
                    serial_number: 1,
                  },
                ];
              return obj;
            })()}
            touched={formik.touched}
            number_inputs={['price','piece_count','width','length']}
            headers={[
              t('service'),
              t('service_code'),
              t('code'),
              t('length'),
              t('width'),
              t('count'),
              t('price'),
              t('total_price'),
              t('category'),
              t('category_code'),
              t('serial_no'),
            ]}
            selectInput={['glass_id', 'glass_work_id']}
            options={{
              glass_id: state.glasses,
              glass_work_id: state.glassWorks,
            }}
            removeLine={handleRemoveLine}
            copyLine={handleCopyLine}
            spans={spans_1}
            units={units}
          />
        </Grid>
        <Grid  container size={12} justifyContent="center">
          <Grid
            
            container
            size={6}
            justifyContent="space-between"
            alignItems={'center'}
            paddingBottom={2}>
            <Grid  size={3}>
              <GreenButton
                label={t('save')}
                fun={() => submit()}
                disabled={isLoading || !formik.dirty || !formik.isValid}
                fullWidth={true}>
                {isLoading ? (
                  <CircularProgress sx={{ color: 'white' }} size={20} />
                ) : (
                  <Save sx={{ color: 'white' }} />
                )}
              </GreenButton>
            </Grid>

            <Grid size={3}>
              <WhiteButton
                label={t('cancel')}
                fun={() => {
                  formik.resetForm();
                  navigate('/orders');
                }}
                fullWidth={true}>
                <Cancel color="error" />
              </WhiteButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default AddOrder ;